import styled from "styled-components";

const Textblock = styled.div`
    grid-area: ftext;
    text-align: center;

    & > p {
        margin: 0;
    }
`;

const FooterText = () => {
    const currentDate = new Date();
    return <Textblock>
        <p>Copyright Shackleton - Britain's Financial Adviser {currentDate.getFullYear()}. All rights reserved.</p>
    </Textblock>
};

export default FooterText;